import { FormattedMessage } from 'react-intl';
import { ReactElement, ReactNode, useEffect, useState } from 'react';

import { PaloConfirmationDialog } from './palo-confirmation-dialog';

export interface PaloReviewReminderProps {
    /** Whether the company's people are due to be checked. */
    due: boolean;
    children: ReactNode;
    onGoToList: () => void;
}

/**
 * The reminder to check the company's people (#2283, #2272).
 *
 * "OK" and the cross both led to the list, so whoever only wanted to close it
 * landed there all the same. One button leads there, "Später" only closes —
 * and it comes back on the next visit, as long as nobody confirmed the data.
 */
export const PaloReviewReminder = ({ due, children, onGoToList }: PaloReviewReminderProps): ReactElement => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(due);
    }, [due]);

    return (
        <PaloConfirmationDialog
            isVisible={visible}
            isSuccessDialog={true}
            title={<FormattedMessage id="app.header.reminder" defaultMessage="Erinnerung" />}
            action={<FormattedMessage id="app.reviewReminder.goToList" defaultMessage="Zur Mitarbeiterliste" />}
            cancelText={<FormattedMessage id="app.reviewReminder.later" defaultMessage="Später" />}
            onCancel={() => setVisible(false)}
            onConfirm={() => {
                setVisible(false);
                onGoToList();
            }}
        >
            {children}
        </PaloConfirmationDialog>
    );
};
